import {defaultIO} from "../DefaultIO";
import {CampaignValueObject} from "../../model/vo/campaign/CampaignValueObject";

export const CampaignIO = Object.freeze(
    defaultIO<CampaignValueObject>(
        '/api/v3/campaigns',
        CampaignValueObject.construct
    )
)